import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import connectionActions from "../../../../redux/connections/actions";
import musicImg from "../../../../assets/images/music-card.png";
import styles from "./style.module.scss";

const SentConnection = ({ setView, setValues }) => {
  const dispatch = useDispatch();
  const { sent = [] } = useSelector((state) => ({
    sent: state.connection.sent,
  }));

  useEffect(() => {
    const getConnectionsList = () => {
      dispatch({
        type: connectionActions.GET_SENT_REQUESTS,
      });
    };
    getConnectionsList();
  }, []);

  return (
    <div className={styles.creditzContainer}>
      <div className={styles.header}>
        <div className={styles.artwork}>Profile</div>
        <div className={styles.sender}>Name</div>
        <div className={styles.role}>Role</div>
        <div className={styles.genre}>Genre</div>
        <div className={styles.date}>Reaction</div>
      </div>
      <div className={`${styles.content} ${styles.acceptedCreditz}`}>
        {sent.map((a, index) => {
          const { user, notification } = a;
          if (notification.status > 1) {
            return;
          }
          return (
            <div key={index}>
              <div className={styles.row}>
                <div>
                  {user?.profileImageUrl && (
                    <img src={user?.profileImageUrl} alt="musicImg" />
                  )}
                </div>
                <div className={styles.sender}>{user?.username}</div>
                <div className={styles.role}>
                  {user?.role && <div>{user.role.split(",")[0]}</div>}
                </div>
                <div className={styles.genre}>
                  {user.genre && <div>{user.genre.split(",")[0]}</div>}
                </div>
                <div className={styles.action}>
                  {notification.status === 0 && (
                    <button className={styles.button_pending}>Pending</button>
                  )}
                  {notification.status === 1 && (
                    <button className={styles.button_2}>View</button>
                  )}
                </div>
              </div>
              {index + 1 < sent.length && <hr className={styles.hr} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

SentConnection.propTypes = {
  setView: PropTypes.func,
  setValues: PropTypes.func,
};
export default SentConnection;
